import { mapState, mapGetters, mapActions } from 'vuex'

/* auth state helpers ------------------------------------------------------- */
export const authComputed = {
  ...mapState('auth', {
    token: (state) => state.token,
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'token',
    'currentUser',
  ]),
}
export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'validateUser',
  'setCurrentToken',
  'setCurrentUser',
])

/* verify state helpers ----------------------------------------------------- */
export const verifyComputed = {
  ...mapState('verify', {
    eventId: (state) => state.eventId,
    eventData: (state) => state.eventData,
    verifMethod: (state) => state.verifMethod,
    verifResponseStatus: (state) => state.verifResponseStatus,
    verifResponseContent: (state) => state.verifResponseContent,
    tableDetail: (state) => state.tableDetail,
  }),
  ...mapGetters('verify', [
    'eventId',
    'eventData',
    'verifMethod',
    'verifResponseStatus',
    'verifResponseContent',
    'tableDetail',
  ]),
}
export const verifyMethods = mapActions('verify', [
  'resetVerifData',
  'setEventId',
  'setEventData',
  'setVerifMethod',
  'setVerifResponseStatus',
  'setVerifResponseContent',
  'setTableDetail',
])
